export default "__VITE_ASSET__BMcFMCHw__"